import { HttpParams } from '@angular/common/http';
import { ConfigStrings, ErrorCodes } from 'src/app/utils/common-classes';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../Auth/auth.service";
export class FileService {
    constructor(httpClient, authService) {
        this.httpClient = httpClient;
        this.authService = authService;
    }
    getFiles(mediaFolderId) {
        let _self = this;
        return new Promise((resolve, reject) => {
            const headers = _self.authService.getHeaders();
            let params = new HttpParams();
            params = params.append('mediaFolderId', mediaFolderId);
            _self.httpClient.get(ConfigStrings.API_URL + "/get-files", { headers: headers, params: params }).subscribe((data) => {
                if (data) {
                    resolve(data);
                }
                else {
                    reject(new Error(ErrorCodes.UNKNOWN_ERROR));
                }
            }, (error) => {
                reject(error);
            });
        });
    }
    createFile(mediaFile) {
        let _self = this;
        return new Promise((resolve, reject) => {
            const headers = _self.authService.getHeaders();
            _self.httpClient.post(ConfigStrings.API_URL + "/create-file", mediaFile, { headers: headers }).subscribe((data) => {
                if (data) {
                    resolve(data);
                }
                else {
                    reject(new Error(ErrorCodes.UNKNOWN_ERROR));
                }
            }, (error) => {
                reject(error);
            });
        });
    }
    editFile(mediaFile) {
        let _self = this;
        return new Promise((resolve, reject) => {
            const headers = _self.authService.getHeaders();
            _self.httpClient.post(ConfigStrings.API_URL + "/edit-file", mediaFile, { headers: headers }).subscribe((data) => {
                if (data) {
                    resolve(data);
                }
                else {
                    reject(new Error(ErrorCodes.UNKNOWN_ERROR));
                }
            }, (error) => {
                reject(error);
            });
        });
    }
    renameFile(mediaFile) {
        let _self = this;
        return new Promise((resolve, reject) => {
            const headers = _self.authService.getHeaders();
            _self.httpClient.post(ConfigStrings.API_URL + "/edit-file", mediaFile, { headers: headers }).subscribe((data) => {
                if (data) {
                    resolve(data);
                }
                else {
                    reject(new Error(ErrorCodes.UNKNOWN_ERROR));
                }
            }, (error) => {
                reject(error);
            });
        });
    }
    deleteFile(mediaFile) {
        let _self = this;
        return new Promise((resolve, reject) => {
            const headers = _self.authService.getHeaders();
            _self.httpClient.post(ConfigStrings.API_URL + "/delete-file", mediaFile, { headers: headers }).subscribe(() => {
                resolve();
            }, (error) => {
                reject(error);
            });
        });
    }
    editPreview(mediaFile) {
        let _self = this;
        return new Promise((resolve, reject) => {
            const headers = _self.authService.getHeaders();
            _self.httpClient.post(ConfigStrings.API_URL + "/edit-file-preview", mediaFile, { headers: headers }).subscribe((data) => {
                if (data) {
                    resolve(data);
                }
                else {
                    reject(new Error(ErrorCodes.UNKNOWN_ERROR));
                }
            }, (error) => {
                reject(error);
            });
        });
    }
    editPreviewTmp(mediaFile) {
        let _self = this;
        return new Promise((resolve, reject) => {
            const headers = _self.authService.getHeaders();
            _self.httpClient.post(ConfigStrings.API_URL + "/edit-file-preview-tmp", mediaFile, { headers: headers }).subscribe((data) => {
                if (data) {
                    resolve(data);
                }
                else {
                    reject(new Error(ErrorCodes.UNKNOWN_ERROR));
                }
            }, (error) => {
                reject(error);
            });
        });
    }
    setFileTranslation(mediaTranslation) {
        let _self = this;
        return new Promise((resolve, reject) => {
            const headers = _self.authService.getHeaders();
            _self.httpClient.post(ConfigStrings.API_URL + "/set-file-translation", mediaTranslation, { headers: headers }).subscribe((data) => {
                if (data) {
                    resolve(data);
                }
                else {
                    reject(new Error(ErrorCodes.UNKNOWN_ERROR));
                }
            }, (error) => {
                reject(error);
            });
        });
    }
    deleteTranslation(mediaTranslation) {
        let _self = this;
        return new Promise((resolve, reject) => {
            const headers = _self.authService.getHeaders();
            _self.httpClient.post(ConfigStrings.API_URL + "/delete-file-translation", mediaTranslation, { headers: headers }).subscribe((data) => {
                if (data) {
                    resolve(data);
                }
                else {
                    reject(new Error(ErrorCodes.UNKNOWN_ERROR));
                }
            }, (error) => {
                reject(error);
            });
        });
    }
    //todo delete
    getFilePreviews() {
        let _self = this;
        return new Promise((resolve, reject) => {
            const headers = _self.authService.getHeaders();
            _self.httpClient.get(ConfigStrings.API_URL + "/get-file-previews", { headers: headers }).subscribe((data) => {
                if (data) {
                    resolve(data);
                }
                else {
                    reject(new Error(ErrorCodes.UNKNOWN_ERROR));
                }
            }, (error) => {
                reject(error);
            });
        });
    }
}
FileService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FileService_Factory() { return new FileService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.AuthService)); }, token: FileService, providedIn: "root" });
